import URL from 'urijs';

export default (urlString: string) => {
	const url = URL(urlString);
	const segments = url.segment();
	return segments[1];
};
